import {initializeApp} from 'firebase/app';
import firebaseConfig from './config';

console.log('Initializing Firebase');
export const firebaseApp = initializeApp(firebaseConfig);
